import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
export default function ROICalculator() {
  const [tables, setTables] = useState("4");
  const [ticketPrice, setTicketPrice] = useState("85");
  const [packagesSold, setPackagesSold] = useState("3");
  const [phone, setPhone] = useState("");
  const tableCount = parseInt(tables) || 4;
  const avgTicket = parseFloat(ticketPrice) || 85;
  const currentPackages = parseInt(packagesSold) || 3;
  const estimatedPackages = Math.max(tableCount * 3, currentPackages + 6);
  const increase = estimatedPackages - currentPackages;
  const additionalCashFlow = (estimatedPackages - currentPackages) * avgTicket * 3;
  const displayCashFlow = Math.round(additionalCashFlow / 10) * 10 || 1530;
  return <section id="calculator" style={{
    backgroundColor: "rgb(31, 58, 46)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(255, 255, 255)",
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: "96px",
    paddingBottom: "96px",
    position: "relative",
    overflow: "hidden"
  }}>
      <div className="absolute inset-0 w-full h-full" style={{
      backgroundImage: 'url("https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694540/img/spa_bg-FPPqL65JPdZuG7KqU6iTxM.webp")',
      backgroundSize: "cover",
      backgroundPosition: "50% 50%",
      backgroundRepeat: "repeat",
      opacity: 0.02,
      position: "absolute"
    }} />

      <div className="page-container relative z-10">
        <div className="flex flex-col items-center text-center mb-12" style={{
        maxWidth: "800px",
        marginInline: "auto"
      }}>
          <p className="mb-3" style={{
          color: "#C8985C",
          fontSize: "11px",
          fontWeight: 600,
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          fontFamily: 'ui-sans-serif, system-ui, sans-serif'
        }}>
            INTERACTIVE ROI CALCULATOR
          </p>

          <h2 style={{
          color: "rgb(255, 255, 255)",
          fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          fontSize: "48px",
          fontWeight: "400",
          lineHeight: "1.15",
          textAlign: "center",
          marginBottom: "16px"
        }}>
            See exactly what you&apos;re{" "}
            <em style={{
            color: "#C8985C",
            fontStyle: "italic"
          }}>
              leaving on the table.
            </em>
          </h2>

          <p style={{
          color: "rgba(255, 252, 247, 0.7)",
          fontFamily: 'ui-sans-serif, system-ui, sans-serif',
          fontSize: "16px",
          fontWeight: "400",
          lineHeight: "24px",
          textAlign: "center"
        }}>
            Our data shows that spas selling packages at the table see a 3x increase in upfront cash.
            <br />
            Calculate your custom projections instantly.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-8 justify-center items-stretch">
          <div className="flex-1 flex flex-col" style={{
          backgroundColor: "rgba(255,255,255,0.05)",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: "16px",
          padding: "32px",
          maxWidth: "480px"
        }}>
            <div className="mb-6">
              <p className="mb-3" style={{
              color: "#C8985C",
              fontSize: "11px",
              fontWeight: 600,
              letterSpacing: "0.08em",
              textTransform: "uppercase"
            }}>
                STEP 1: HOW MANY MASSAGE TABLES DO YOU HAVE?
              </p>
              <Select value={tables} onValueChange={setTables}>
                <SelectTrigger style={{
                color: "rgb(255, 255, 255)",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                backgroundColor: "rgba(255,255,255,0.05)",
                borderRadius: "14.4px",
                border: "1px solid rgba(255,255,255,0.1)",
                padding: "10px 12px",
                width: "120px",
                height: "42px"
              }}>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => <SelectItem key={n} value={String(n)}>
                      {n} Table{n !== 1 ? "s" : ""}
                    </SelectItem>)}
                </SelectContent>
              </Select>
            </div>

            <div className="mb-6">
              <p className="mb-3" style={{
              color: "#C8985C",
              fontSize: "11px",
              fontWeight: 600,
              letterSpacing: "0.08em",
              textTransform: "uppercase"
            }}>
                STEP 2: WHAT&apos;S YOUR AVERAGE TICKET PRICE? ($)
              </p>
              <div className="flex items-center gap-2 w-full" style={{
              backgroundColor: "rgba(255,255,255,0.05)",
              borderRadius: "14.4px",
              border: "1px solid rgba(255,255,255,0.1)",
              padding: "0 12px",
              height: "42px"
            }}>
                <span style={{
                color: "rgba(255,255,255,0.6)",
                fontSize: "14px"
              }}>$</span>
                <input type="number" value={ticketPrice} onChange={e => setTicketPrice(e.target.value)} className="flex-1 bg-transparent outline-none border-none" style={{
                color: "rgb(255, 255, 255)",
                fontSize: "14px",
                fontWeight: "400",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif'
              }} />
              </div>
            </div>

            <div className="mb-6">
              <p className="mb-3" style={{
              color: "#C8985C",
              fontSize: "11px",
              fontWeight: 600,
              letterSpacing: "0.08em",
              textTransform: "uppercase"
            }}>
                STEP 3: HOW MANY PREPAID PACKAGES DID YOU SELL LAST MONTH?
              </p>
              <div className="flex items-center w-full" style={{
              backgroundColor: "rgba(255,255,255,0.05)",
              borderRadius: "14.4px",
              border: "1px solid rgba(255,255,255,0.1)",
              padding: "0 12px",
              height: "42px"
            }}>
                <input type="number" value={packagesSold} onChange={e => setPackagesSold(e.target.value)} className="flex-1 bg-transparent outline-none border-none" style={{
                color: "rgb(255, 255, 255)",
                fontSize: "14px",
                fontWeight: "400",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif'
              }} />
              </div>
            </div>

            <div className="flex-1" />

            <div className="pt-4 mt-4" style={{
            borderTop: "1px solid rgba(255,255,255,0.15)"
          }}>
              <div className="flex items-center gap-3">
                <span style={{
                color: "#C8985C",
                flexShrink: 0
              }}>
                  <span dangerouslySetInnerHTML={{
                  __html: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="16" height="20" x="4" y="2" rx="2"></rect><line x1="8" x2="16" y1="6" y2="6"></line><line x1="16" x2="16" y1="14" y2="18"></line><path d="M16 10h.01"></path><path d="M12 10h.01"></path><path d="M8 10h.01"></path><path d="M12 14h.01"></path><path d="M8 14h.01"></path><path d="M12 18h.01"></path><path d="M8 18h.01"></path></svg>`
                }} />
                </span>
                <span style={{
                color: "rgba(255,255,255,0.6)",
                fontSize: "13px",
                fontWeight: 400
              }}>
                  Formulas based on live operations data from 300+ active spas.
                </span>
              </div>
            </div>
          </div>

          <div className="flex-1 flex flex-col" style={{
          backgroundColor: "#FFFCF7",
          borderRadius: "16px",
          padding: "32px",
          maxWidth: "480px"
        }}>
            <div className="flex items-center gap-2 mb-4">
              <span style={{
              color: "#C8985C"
            }}>
                <span dangerouslySetInnerHTML={{
                __html: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path></svg>`
              }} />
              </span>
              <span style={{
              color: "#C8985C",
              fontSize: "11px",
              fontWeight: 600,
              letterSpacing: "0.08em",
              textTransform: "uppercase"
            }}>
                PROJECTION RESULTS
              </span>
            </div>

            <p className="mb-5" style={{
            color: "rgba(42, 45, 43, 0.8)",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif',
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px"
          }}>
              Great. Based on{" "}
              <strong style={{
              fontWeight: 700
            }}>{tableCount} tables</strong> and a{" "}
              <strong style={{
              fontWeight: 700
            }}>${avgTicket} average ticket</strong>, PrepayQR would have
              generated:
            </p>

            <p className="mb-2" style={{
            color: "#C8985C",
            fontSize: "11px",
            fontWeight: 600,
            letterSpacing: "0.08em",
            textTransform: "uppercase"
          }}>
              ADDITIONAL UPFRONT CASH FLOW
            </p>

            <div className="flex items-baseline gap-2 mb-3">
              <span style={{
              fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
              fontSize: "52px",
              fontWeight: 700,
              color: "#1F3A2E",
              lineHeight: 1
            }}>
                ${displayCashFlow.toLocaleString()}
              </span>
              <span style={{
              color: "rgba(42, 45, 43, 0.6)",
              fontSize: "14px",
              fontWeight: 400
            }}>
                / month
              </span>
            </div>

            <div className="mb-6">
              <span style={{
              color: "rgb(61, 139, 110)",
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "16px",
              backgroundColor: "rgba(61, 139, 110, 0.1)",
              borderRadius: "8.4px",
              padding: "4px 12px",
              display: "inline-block"
            }}>
                By selling an estimated {estimatedPackages} packages (+{increase} increase).
              </span>
            </div>

            <hr style={{
            borderColor: "rgba(42,45,43,0.12)",
            marginBottom: "20px"
          }} />

            <p className="mb-3" style={{
            color: "#C8985C",
            fontSize: "11px",
            fontWeight: 600,
            letterSpacing: "0.08em",
            textTransform: "uppercase"
          }}>
              GET YOUR LIVE QR CODE TO TEST THIS
            </p>

            <div className="flex gap-3 mb-3">
              <input type="tel" placeholder="Enter your phone number" value={phone} onChange={e => setPhone(e.target.value)} className="flex-1" style={{
              backgroundColor: "#FFFCF7",
              border: "1px solid #E9E9E3",
              borderRadius: "14.4px",
              padding: "10px 16px",
              fontSize: "14px",
              color: "#2A2D2B",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif',
              outline: "none",
              boxShadow: "rgba(0,0,0,0.05) 0px 1px 2px 0px"
            }} />
              <button style={{
              fontFamily: 'ui-sans-serif, system-ui, sans-serif',
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "16px",
              letterSpacing: "0.6px",
              backgroundColor: "rgb(200, 152, 92)",
              borderRadius: "14.4px",
              border: "0px",
              padding: "10px 16px",
              textTransform: "uppercase",
              textAlign: "center",
              color: "#1F3A2E",
              cursor: "pointer",
              whiteSpace: "nowrap",
              transition: "opacity 0.2s"
            }} onMouseEnter={e => e.currentTarget.style.opacity = "0.85"} onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
                SEND MY QR CODE
              </button>
            </div>

            <div className="flex items-center gap-2">
              <span style={{
              color: "#C8985C",
              flexShrink: 0
            }}>
                <span dangerouslySetInnerHTML={{
                __html: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>`
              }} />
              </span>
              <span style={{
              color: "rgba(42, 45, 43, 0.55)",
              fontSize: "12px",
              fontWeight: 400
            }}>
                No credit card. No legal review. Just a phone number.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}